<template>
  <div :class="[hours.length > 1 ? 'rhg-hours-grid' : 'rhg-hours-grid-one']">
    <text-list-with-title v-for="(hour, key) in hours" :key="`hour-${key}`" :icon="hour.icon" :title="hour.title"
      :items="hour.intervals" :class="[hours.length == 1 ? 'rhg-text-list-with-title-one' : '', hours.length == 2 ? 'rhg-text-list-with-title-two' : 'rhg-text-list-with-title']" />
  </div>
</template>

<script>
import TextListWithTitle from '../hours-grid/TextListWithTitle.vue'

export default {
  name: 'HoursGrid',
  components: {
    TextListWithTitle
  },
  props: {
    hours: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss">
@import "../../../Common/Colors.scss";

.rhg-hours-grid {
  display: flex;
  gap: 24px;
  justify-content: flex-start;

  .rhg-text-list-with-title {
    padding-left: 2rem;
    padding-top: 1rem;

    &:first-of-type {
      border-left: unset;
      padding-left: 0rem;
    }

    &:not(:first-of-type) {
      border-left: 1px solid rgba($black, 0.3);
      padding-left: 34px;
    }
  }
}
.rhg-text-list-with-title-one  {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 12px;
  border-left: none;
  flex-wrap: wrap;
  h3 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 24px;
  }
  p {
    display: flex;
    align-items: center;
    width: max-content;
    margin: 0;
  }
  .rhg-text-list-with-title-hour{
    padding-left: 4px;
  }
}

@media (max-width: 992px) {
  .rhg-hours-grid {
    flex-direction: column;

    .rhg-text-list-with-title {
      border-left: unset;
      border-top: 1px solid rgba($black, 0.3);
      padding: 16px 0;

      &:first-of-type {
        border-top: unset;
        padding-top: 0.5rem;
      }
      &:not(:first-of-type) {
        border-left: none;
        padding-left: 0;
      }
    }
  }
}

html[dir="rtl"] {
  .rhg-text-list-with-title {
      border-right: 1px solid rgba($black, 0.3);
      border-left: unset;
      padding-right: 2rem;
      border-left: unset;

    &:first-of-type {
      border-right: unset;
      padding-right: 0rem;
    }
    &:not(:first-of-type) {
      border-left: none;
      padding-left: 0;
    }
  }

  .rhg-text-list-with-title-one {
    p {
      float: right;
      margin-right: 0;
      margin-left: 6rem;
    }
    h3 {
      margin-left: 24px;
      margin-right: 0;
    }
  }

  @media(max-width: 992px) {
    .rhg-text-list-with-title {
        border-right: unset;
        padding-right: 0rem;

        &:first-of-type {
          border-right: unset;
        }
      }
  }
}
</style>
